import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import { history } from "../../_helpers";
import { pageNotes, modalAlert } from "../../_actions";
import { Row, Col, FormGroup, FormControl, Button } from "react-bootstrap";
import NoteAlertCardTelemetry from "../NoteAlertCardTelemetry";
import NoteObservationCard from "../NoteObservationCard";
import CommentCard from "../CommentCard";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import FontAwesome from "react-fontawesome";
import Moment from "react-moment";
import Slider from "react-slick";
import _ from "lodash";
import { Link } from "react-router-dom";
import "./index.css";

class ViewNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: null,
      alertTraceData: null,
      observationAssignmentData: null,
      addNewComment: ""
    };
  }

  componentDidMount = () => {
    if (this.props.match.params !== null && this.props.configList) {
      const noteID = this.props.match.params.noteID;
      this.getNote(noteID);
    }
    this.props.pageNotes();
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.match.params === null || nextProps.match.params === null) {
      return;
    }

    const siteConfigUpdated = JSON.stringify(this.props.configList) !== JSON.stringify(nextProps.configList);
    const currentNoteID = this.props.match.params.noteID;
    const nextNoteID = nextProps.match.params.noteID;

    if (siteConfigUpdated || currentNoteID !== nextNoteID) {
      this.getNote(nextNoteID);
    }
  };

  getNote = id => {
    const url = "/api/v1/notes/" + id + "/";
    const errorMsg = "Unable to get the current note details.";
    api
      .getFetch(url, "", this.props.user.token, errorMsg)
      .then(json => {
        this.setState(() => {
          return {
            note: json,
            logEntriesList: json.workflow_log_entries
          };
        });
      })
      .then(() => {
        this.getCommentsForThisNote(id);
        this.setAlertTelemetryData();
        this.setObservationAssignmentData();
      });
  };

  setAlertTelemetryData = () => {
    if (!this.state.note || this.state.note.alert_assignments.length < 1) {
      this.setState(() => {
        return { alertTraceData: [] };
      });
      return null;
    }

    const alertObj = this.state.note.alert_assignments;
    this.setState(() => {
      return { alertTraceData: alertObj };
    });
  };

  setObservationAssignmentData = () => {
    if (!this.state.note || this.state.note.observation_assignments.length < 1) {
      this.setState(() => {
        return { observationAssignmentData: [] };
      });
      return null;
    }

    this.setState(() => {
      return { observationAssignmentData: this.state.note.observation_assignments };
    });
  };

  onChange = e => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(() => {
      return { state };
    });
  };

  getCommentDetails = () => {
    if (this.state.addNewComment.length > 0 && this.props.match.params.noteID) {
      return {
        note: this.props.match.params.noteID,
        comment: this.state.addNewComment
      };
    } else {
      return null;
    }
  };

  postNewComment = () => {
    const commentDetails = this.getCommentDetails();
    if (commentDetails !== null) {
      this.submitComment(commentDetails);
    }
  };

  submitComment = opts => {
    const url = "/api/v1/note_comments/";
    const errorMsg = "Unable to submit comment for this note.";
    api.postFetch(url, opts, this.props.user.token, errorMsg).then(json => {
      if (json) {
        this.setState({ commentsList: [...this.state.commentsList, json] });
      }
    });

    this.setState({
      addNewComment: ""
    });
  };

  getCommentsForThisNote = id => {
    const params = {
      note: id
    };
    const url = "/api/v1/note_comments/";
    const errorMsg = "Unable to get the comments for this note.";
    api
      .getFetch(url, params, this.props.user.token, errorMsg)
      .then(json => {
        this.setState(() => {
          return { commentsList: json.results };
        });
      })
      .then(() => {
        if (this.state.logEntriesList.length > 0) {
          _.each(this.state.logEntriesList, item => {
            this.setState({ commentsList: [...this.state.commentsList, item] });
          });
        }
      });
  };

  renderResolveButton = note => {
    if (note.can_be_resolved) {
      const resolveURL = "/note/" + note.id + "/resolve";
      return (
        <Link className="main-title-action btn btn-primary" to={resolveURL}>
          Resolve
        </Link>
      );
    } else {
      return "";
    }
  };

  renderRetractResolveButton = note => {
    if (note.resolution_can_be_retracted) {
      const url = "/note/" + note.id + "/retract_resolve";
      return (
        <Link className="main-title-action btn btn-default" to={url}>
          Retract Resolution
        </Link>
      );
    } else {
      return "";
    }
  };

  renderSignoffButton = note => {
    if (note.can_be_signed_off) {
      const url = "/note/" + note.id + "/sign_off";
      return (
        <Link className="main-title-action btn btn-primary" to={url}>
          Sign Off
        </Link>
      );
    } else {
      return "";
    }
  };

  renderAssignOwnerButton = note => {
    if (note.can_be_assigned) {
      const url = "/note/" + note.id + "/assign_owner";
      return (
        <Link className="main-title-action link" to={url}>
          {note.assigned_to ? "Change" : "Assign Owner"}
        </Link>
      );
    } else {
      return "";
    }
  };

  renderRefuseSignoffButton = note => {
    if (note.signoff_can_be_refused) {
      const url = "/note/" + note.id + "/refuse_signoff";
      return (
        <Link className="main-title-action btn btn-danger" to={url}>
          Refuse Signoff
        </Link>
      );
    } else {
      return "";
    }
  };

  renderRetractSignoffButton = note => {
    if (note.signoff_can_be_retracted) {
      const url = "/note/" + note.id + "/retract_signoff";
      return (
        <Link className="main-title-action btn btn-default" to={url}>
          Retract Signoff
        </Link>
      );
    } else {
      return "";
    }
  };

  renderMergeButton = note => {
    if (note.can_be_merged) {
      const url = "/note/" + note.id + "/merge";
      return (
        <Link className="main-title-action btn btn-default" to={url}>
          Merge
        </Link>
      );
    } else {
      return "";
    }
  };

  renderBackToDevicesBtn = () => {
    if (this.props.location.state && this.props.location.state.fromAllNote) {
      return (
        <a className="link" onClick={history.goBack}>
          <FontAwesome name="arrow-left" size="lg" /> Back to Notes List
        </a>
      );
    } else {
      return (
        <Link to="/notes">
          <FontAwesome name="arrow-left" size="lg" /> Back to Notes List
        </Link>
      );
    }
  };

  renderTitlePanel = note => {
    let tempOwner = "";

    if (!this.state.note.assigned_to) {
      tempOwner = <span className="owner-datum-value unassigned">Unassigned</span>;
    } else {
      tempOwner = <span className="owner-datum-value">{this.state.note.assigned_to.display_name}</span>;
    }
    return (
      <div>
        <div className="mainTitle">
          <div className="breadCrumb">{this.renderBackToDevicesBtn()}</div>
          <h1>
            {this.state.note.title + " (ID: " + this.state.note.id + ")"}
            <div className="actionCon">
              {this.renderResolveButton(this.state.note)}
              {this.renderSignoffButton(this.state.note)}
              {this.renderRefuseSignoffButton(this.state.note)}
              {this.renderRetractResolveButton(this.state.note)}
              {this.renderRetractSignoffButton(this.state.note)}
              {this.renderMergeButton(this.state.note)}
            </div>
          </h1>
          <h5>
            <span className="device-datum">Owner:</span>
            {tempOwner}
            {this.renderAssignOwnerButton(note)}
          </h5>
        </div>
      </div>
    );
  };

  renderCommentInputPanel = () => {
    return (
      <div className="noteInputBox">
        <form>
          <FormGroup controlId="formBasicText" className="form-panel">
            <FormControl
              name="addNewComment"
              componentClass="textarea"
              placeholder="Write a comment..."
              className="commentBox"
              value={this.state.addNewComment}
              onChange={this.onChange}
            />
            <FormControl.Feedback />
          </FormGroup>
        </form>
        <div className="line-separator" />
        <div className="attachmentBox">
          <Button className="btn btn-primary pull-right post-button" onClick={this.postNewComment}>
            Post
          </Button>
        </div>
      </div>
    );
  };

  sortCommentsBasedOnTime = () => {
    if (!this.state.commentsList) {
      return null;
    }

    this.state.commentsList.sort(function compare(a, b) {
      const dateA = new Date(a.created);
      const dateB = new Date(b.created);
      return dateB - dateA;
    });
  };

  renderCommentsCard = () => {
    if (!this.state.commentsList) {
      return null;
    }

    this.sortCommentsBasedOnTime();
    const commentsCardListToRender = [];
    const tempCommentList = this.state.commentsList;

    _.each(tempCommentList, (item, key) => {
      return commentsCardListToRender.push(
        <div key={key}>
          <CommentCard item={item} />
        </div>
      );
    });

    return commentsCardListToRender;
  };

  renderAlertTelemetryCard = (item, key, listLength) => {
    const currentCount = key + 1;
    return (
      <div className="" key={key}>
        <NoteAlertCardTelemetry alert={item.alert} alertIndex={currentCount} alertCount={listLength} show={true} />
      </div>
    );
  };

  renderObservationCard = (item, key, listLength) => {
    const currentCount = key + 1;
    return (
      <div key={key}>
        <NoteObservationCard
          observation={item.observation}
          observationIndex={currentCount}
          observationCount={listLength}
        />
      </div>
    );
  };

  renderNoteAttachments = () => {
    const { alertTraceData, observationAssignmentData } = this.state;

    if (!alertTraceData && !observationAssignmentData) {
      return null;
    }

    const combinedAttachedData = [];
    if (alertTraceData && alertTraceData.length > 0) {
      _.each(alertTraceData, item => {
        return combinedAttachedData.push(item);
      });
    }

    if (observationAssignmentData && observationAssignmentData.length > 0) {
      _.each(observationAssignmentData, item => {
        return combinedAttachedData.push(item);
      });
    }

    if (combinedAttachedData && combinedAttachedData.length < 1) {
      return (
        <div className="">
          <div className="loading-con">No alerts or observations have been assigned to this Note.</div>
        </div>
      );
    }

    const dataSortedByDate = _.sortBy(combinedAttachedData, item => {
      return new Date(item.created);
    });

    const combinedNotesAttachmentList = [];
    _.each(dataSortedByDate, (item, key) => {
      if (item.alert) {
        return combinedNotesAttachmentList.push(this.renderAlertTelemetryCard(item, key, dataSortedByDate.length));
      } else {
        return combinedNotesAttachmentList.push(this.renderObservationCard(item, key, dataSortedByDate.length));
      }
    });

    return combinedNotesAttachmentList;
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  renderMergedInto = () => {
    if (!this.state.note.merged_into) {
      return "";
    } else {
      const url = "/note/" + this.state.note.merged_into.id + "/view";
      return (
        <div className="datum">
          <span className="datum-name">Merged Into</span>
          <span className="datum-value">
            <Link to={url}>Note #{this.state.note.merged_into.id}</Link>
          </span>
        </div>
      );
    }
  };

  renderCreatedBy = () => {
    if (!this.state.note.created_by) {
      return "";
    } else {
      return (
        <div className="datum">
          <span className="datum-name">Created By</span>
          <span className="datum-value">{this.state.note.created_by.display_name}</span>
        </div>
      );
    }
  };

  renderResolvedBy = () => {
    if (!this.state.note.resolved_by) {
      return "";
    } else {
      return (
        <div className="datum">
          <span className="datum-name">Resolved By</span>
          <span className="datum-value">{this.state.note.resolved_by.display_name}</span>
        </div>
      );
    }
  };

  renderSignedOffBy = () => {
    if (!this.state.note.signed_off_by) {
      return "";
    } else {
      return (
        <div className="datum">
          <span className="datum-name">Signed Off By</span>
          <span className="datum-value">{this.state.note.signed_off_by.display_name}</span>
        </div>
      );
    }
  };

  renderMainContent = () => {
    // hide slider dot if it's over 15 slide.
    const settings = {
      dots: this.state.alertTraceData && this.state.alertTraceData.length > 15 ? false : true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true
    };

    return (
      <div className="mainContent">
        <Row className="row-eq-height">
          <Col md={3} sm={12}>
            <div className="panel-div note-summary-panel">
              <h3>Note Summary</h3>
              <div className="datum">
                <span className="datum-name">Status</span>
                <span className="datum-value">{this.state.note.status_display}</span>
              </div>
              {this.renderMergedInto()}
              <div className="datum">
                <span className="datum-name">Date Created</span>
                <span className="datum-value">
                  <Moment format="D MMMM YYYY, hh:mma">{this.state.note.created}</Moment>
                </span>
              </div>
              {this.renderCreatedBy()}
              {this.renderResolvedBy()}
              {this.renderSignedOffBy()}
            </div>
          </Col>
          <Col md={9} sm={12} className="slider-column">
            <div className="panel-div">
              <div className="slider-container">
                <Slider {...settings}>{this.renderNoteAttachments()}</Slider>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="timeline">
          <Col md={12} sm={12}>
            <div className="panel-div">
              <h3>Note Description</h3>
              <div className="note-description">{this.state.note.description}</div>

              <h3>Note Timeline</h3>
              {this.renderCommentInputPanel()}
              {this.renderCommentsCard()}
              <hr />
              <div className="noteCreated">
                This note was created on <Moment format="DD MMM YYYY">{this.state.note.created}</Moment> at{" "}
                <Moment format="hh:mm">{this.state.note.created}</Moment>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render = () => {
    const { note } = this.state;

    if (note !== null) {
      return (
        <div className="viewNotePage">
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderTitlePanel(note)}
              {this.renderMainContent()}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  };
}

function mapStateToProps(state) {
  const { notedata } = state;
  const { noteCreatePermission } = state.note;
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    user,
    notedata,
    configList,
    noteCreatePermission
  };
}

export default connect(
  mapStateToProps,
  {
    pageNotes,
    modalAlert
  }
)(ViewNote);



// WEBPACK FOOTER //
// ./src/_components/ViewNote/index.js